import * as moment from "moment";
import { AppConstants } from "src/app/common/enum/app.constants";
import { EnumTipoConsultaOptimizado } from "src/app/common/enum/TipoPersona.enum";
import { PerfilBusqueda } from "src/app/model/session/perfil-busqueda.model";

export class Transacciones {
  public TransaccionId: string;
  public Nombre: string;
  public SNombre: string;
  public ApellidoPaterno: string;
  public ApellidoMaterno: string;
  public RFC: string;
  public PersonalidadFiscalId: string;
  public MontoInicial: number;
  public MontoFinal: number;
  public FechaInicial: string;
  public FechaFinal: string;
  public Referencia: string;
  public Pagina: number;
  public UsuarioId: number;
  public ClienteId: string;
  public Perfil: number;
  public EsCredito: number;
  public EsCaptacion: number;
  public Seleccionado: number;
  public PersonalidadFiscal: [];
  public TipoBusqueda: number;
  public ClaveCia: string;
  public Contrato: string;
  public TipoFecha: number;
  public FacturaReferencia: string;
  public Recibo: string;
  public Chasis: string;
  public ActividadVulnerableId: number;
  //public IdNotificacion: string;
  public BatchNumber: number;
  public BatchSize: number;
  public TipoConsulta: number;
  public imprimirReporte: boolean = true;
  public viewCheck: boolean = false;
  public ProductoId: number = -1;
  public esReportada: boolean = false;
  public casoId: number;

  constructor() {
    const formatoSalida = "YYYY-MM-DD";
    const formatoEntrada = "YYYY-MM-DDTHH:mm:ss Z";
    var fechainicial = moment(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      formatoEntrada,
    );
    var fechafinal = moment(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      formatoSalida,
    );
    this.TransaccionId = "";
    this.FechaInicial = fechainicial.format(formatoSalida);
    this.FechaFinal = fechafinal.format(formatoSalida);
    this.Pagina = 1;
    this.Nombre = "";
    this.SNombre = "";
    this.ApellidoPaterno = "";
    this.ApellidoMaterno = "";
    this.UsuarioId = 0;
    this.ClienteId = "";
    this.RFC = "";
    this.Contrato = "";
    this.TipoBusqueda = 1;
    this.PersonalidadFiscalId = "-1";
    this.FacturaReferencia = "";
    this.Recibo = "";
    this.Chasis = "";
    this.ActividadVulnerableId = 0;
    this.BatchNumber = 1;
    this.BatchSize = AppConstants.NUM_PAGES * AppConstants.ROWS_PER_PAGE + 1;
    this.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
    this.casoId = 0;
  }
}
